import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PriceType} from "../../types/price.type";
import {ServiceAreasServiceType} from "../../../service-areas/angular/types/service-areas-service.type";
import {ProgramLocationType} from "../../types/program-location.type";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {PricePlanAlertsService} from "../../services/price-plan-alerts.service";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";
import {PricePlanRequestsService} from "../../services/price-plan-requests.service";
import {ServiceAreasService} from "../../../service-areas/services/service-areas-service.service";

export class ProgramServiceAreaViewComponent implements IController {

  programId: string;
  priceType: PriceType;
  accountId: string;

  public program: any;
  public defaultServiceAreaIdCount: number = 2;
  public serviceAreasRef;
  public headerReady = false;
  public serviceAreas = {
    list: [],
    selectedIds: {
      pickups: [],
      dropoffs: []
    }
  };
  public cardsEnabledByIdMap: Object = {};
  public excludeOriginIds: any[] = [];
  public isSaveAvailable: boolean;
  public excludeServiceAreasIdsByOriginMap: Object = {};
  public serviceAreaServiceTypes: ServiceAreasServiceType[];
  public packagesOptionsIds: string[] = [];
  public priceTypes: typeof PriceType = PriceType;

  constructor(private $serviceArea, private $log, private $stateParams, private serviceAreasService: ServiceAreasService,
              private pricePlanConstant, private PricePlanService, private confirmDialogService: ConfirmDialogService,
              private pricePlanRequestsService: PricePlanRequestsService, private pricePlanAlertsService: PricePlanAlertsService, private pricePlanDialogService: PricePlanDialogService, private bringozLoaderService: BringozLoaderService) {
    this.serviceAreasRef = this.$serviceArea();
    this.serviceAreaServiceTypes = [ServiceAreasServiceType.Pricing]
  }

  $onInit() {
    this.initValues();
  }

  initValues() {
    const query = {
      serviceTypes: ['Pricing']
    }

    this.bringozLoaderService.on();
    this.serviceAreasService.getAll(query)
      .then((serviceAreas: any[]) => {
        const itemsToDisplay = serviceAreas.length > this.defaultServiceAreaIdCount ? this.defaultServiceAreaIdCount : serviceAreas.length;
        this.serviceAreas.list = serviceAreas;

        for (let i = 0; i < itemsToDisplay; i++) {
          let areaId = serviceAreas[i].areaId;
          this.serviceAreas.selectedIds.pickups.push(areaId);
          this.serviceAreas.selectedIds.dropoffs.push(areaId);
        }

        this.headerReady = true;
        this._getPricePlanServiceZones();
      })
      .catch((error) => {
        if (error) {
          this.$log.debug(error);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    this._getProgramPackageOptions();
  }

  onSaveProgram(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {

        const originWithoutLocation = _.find(this.program.areaData, (areaData) => {
          return !areaData.data.length
        })

        if (!!originWithoutLocation) {
          this.pricePlanAlertsService.updatePreferencesOriginMissingLocationsWarning(originWithoutLocation)
          return;
        }

        this.PricePlanService.editProgramConfiguration(this.programId, this.program, this.accountId)
          .then((program) => {
            this.program = program;
            this.isSaveAvailable = false;
          })
      }
    }
  }

  selectAreasDialog(event) {
    this.pricePlanDialogService.selectAreaDialog(event, this.serviceAreas.list, this.serviceAreas.selectedIds.pickups,
      this.serviceAreas.selectedIds.dropoffs).then((result: any) => {
        this.serviceAreas.selectedIds.pickups = result.selectedPickups;
        this.serviceAreas.selectedIds.dropoffs = result.selectedDropoffs;
        this._getPricePlanServiceZones();
      }
    ).catch(() => this.$log.debug);
  }


  ///// NEW /////


  onAddOrigin($event) {
    this.excludeOriginIds = _.map(this.program.areaData, 'id');
    const dataItem = {
      isView: true,
      id: undefined,
      text: undefined,
      entityType: ProgramLocationType.AREA,
      data: []
    }

    if (!this.program.areaData) {
      this.program.areaData = [];
    }

    this.program.areaData.push(dataItem);
    this._onDataChange();
  }

  onAddZone(areaData, $event?) {
    this.cardsEnabledByIdMap[areaData.id] = true;
    this.excludeServiceAreasIdsByOriginMap[areaData.id] = _.map(areaData.data, 'toId');
    // this.excludeServiceAreasIdsByOriginMap[areaData.id] = _.map(areaData.data, 'toId').concat([areaData.id]);

    const dataItem: any = {
      name: undefined,
      fromId: areaData.id,
      fromEntityType: areaData.entityType,
      toId: undefined,
      toEntityType: ProgramLocationType.AREA
    }

    if (this.priceType === this.priceTypes.ByPackageSize) {
      dataItem.combinedPackageSizePriceDataMap = {}
    }

    if (!areaData.data) {
      areaData.data = [];
    }

    areaData.data.push(dataItem);
    this._onDataChange();
  }

  onUpdateZone(zone, index, areaData) {
    this.excludeServiceAreasIdsByOriginMap[areaData.id] = _.uniq(_.get(this.excludeServiceAreasIdsByOriginMap, areaData.id, []).concat([zone.toId]))
    areaData.data[index] = zone;
    this._onDataChange();
  }

  onDeleteOrigin(areaData, $index) {
    if ($index > -1) {
      const text = 'Are you sure you want to delete this origin?';
      this.confirmDialogService.confirm('Delete Origin', text)
        .then(() => {
          if (!!this.program.areaData[$index].isView) {
            this._removeViewOrigin($index)
            this._onDataChange();
          } else {
            this.PricePlanService.deleteRelationPricePlanPreferences(this.programId, areaData.id)
              .then(() => {
                this._removeViewOrigin($index);
              })
            // SERVER API REMOVE ORIGIN
          }
        })
    }
  }

  onDeleteZone(zone, areaDataIndex) {
    if (zone.id) {
      this.PricePlanService.deleteRelationPricePlanPreferences(this.programId, zone.fromId, zone.toId)
        .then(() => {
          this._removeViewLocation(zone, areaDataIndex);
          this._onDataChange(false);
        })
    } else {
      this._removeViewLocation(zone, areaDataIndex);
      this._onDataChange(true);
    }
  }

  onCancelChanges() {
    this.initValues();
  }

  onOriginLocationSelect(areaData, serviceArea) {

    if (!serviceArea) {
      return;
    }

    areaData.id = _.get(serviceArea, 'id');
    areaData.text = _.get(serviceArea, 'areaName');

    this.cardsEnabledByIdMap[areaData.id] = true;
    this.excludeOriginIds = _.uniq(this.excludeOriginIds.concat([serviceArea.id]));
    this._onDataChange();

    this.onAddZone(areaData);
  }

  private _getProgramPackageOptions() {
    this.pricePlanRequestsService.getPricePlanPreferences(this.programId, ['PackageSize'], this.accountId)
      .then((res) => {
        this.packagesOptionsIds = _.chain(_.get(res, 'data[0].value', []))
          .filter((packageItem) => {
            return !!packageItem.enabled || !!packageItem.parentEnabled
          })
          .map('id')
          .value();
      })
  }

  private _getPricePlanServiceZones() {
    const fromData = _.map(this.serviceAreas.selectedIds.pickups, (id) => {
        return {locationId: id, entityType: 'Area'}
      }),
      toData = _.map(this.serviceAreas.selectedIds.dropoffs, (id) => {
        return {locationId: id, entityType: 'Area'}
      });

    if (!_.isEmpty(fromData) && !_.isEmpty(toData)) {
      this.PricePlanService.getProgramData(this.programId, this.accountId, fromData, toData)
        .then((program) => {
          this.program = program;
          this.isSaveAvailable = false;
        })
    }
  }

  private _removeViewOrigin(index) {
    const areaDataCopy = angular.copy(this.program.areaData);
    areaDataCopy.splice(index, 1);

    this.program.areaData = areaDataCopy;
  }

  private _removeViewLocation(location, areaDataIndex) {
    const areaIndex = _.findIndex(this.program.areaData[areaDataIndex].data, (l: any) => {
      return l.toId === location.toId;
    })

    if (areaIndex > -1) {
      const areaDataCopy = angular.copy(this.program.areaData[areaDataIndex]);
      areaDataCopy.data.splice(areaIndex, 1);

      this.program.areaData[areaDataIndex] = areaDataCopy;
    }
  }

  private _onDataChange(value?) {
    this.isSaveAvailable = _.isUndefined(value) ? true : value;
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('programServiceAreaView', {
    bindings: {
      programId: '<',
      priceType: '<',
      accountId: '<?'
    },
    template: require('./program-service-area-view.html').default,
    controller: ProgramServiceAreaViewComponent
  });
